import { render } from "./table_persons.vue?vue&type=template&id=f79ea2da"
import script from "./table_persons.vue?vue&type=script&lang=js"
export * from "./table_persons.vue?vue&type=script&lang=js"

import "./table_persons.vue?vue&type=style&index=0&id=f79ea2da&lang=css"

import exportComponent from "C:\\Projekty\\Adaste\\vue-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__